// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index_" + {"195":"2a9dc4056018d70b5c62","421":"f267f12793902ed3e85e"}[chunkId] + "_" + chunkId + ".js";
};